import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import grey from "@material-ui/core/colors/grey";
import red from "@material-ui/core/colors/red";

let theme = createMuiTheme({
	spacing: 8, // Default is 8
	typography: {
		fontSize: 14,
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
	},
	palette: {
		primary: {
			main: "#E21833",
		},
		secondary: grey,
		background: { default: "#f0f2f5" },
	},
	shape: {
		borderRadius: `0.25rem`,
	},
});
theme = {
	...theme,
	overrides: {
		MuiCard: { root: { border: "1px solid rgba(0, 0, 0, 0.125)" } },
		MuiCardHeader: {
			root: { padding: theme.spacing(2, 2, 1, 2) },
		},
		MuiCardContent: { root: { padding: theme.spacing(1, 2) } },
		MuiTableCell: {
			head: {
				fontWeight: 600,
			},
			sizeSmall: {
				padding: `6px 8px 6px 8px`,
			},
		},
		MuiButton: {
			label: {
				textTransform: "none",
			},
		},
	},
};
export default theme;
